{
  "name": "06 Time Bonus",
  "title": "AddTimePerk",
  "description": "AddTimePerkDescription1",
  "stat": 11,
  "lockFlag": 22
}